/**
 * Veltrona — cart page: live quantity updates, removal and order notes.
 */
(() => {
  'use strict';

  const V = window.Veltrona;

  class VtCartPage extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.sectionId = this.dataset.section;
      this.queue = Promise.resolve();

      this.timers = new Map();
      this.addEventListener('change', (e) => {
        const input = e.target.closest('input[data-key]');
        if (!input) return;
        const key = input.dataset.key;
        clearTimeout(this.timers.get(key));
        this.timers.set(key, setTimeout(() => this.update(key, Number(input.value)), 350));
      });

      this.addEventListener('click', (e) => {
        const remove = e.target.closest('[data-remove-line]');
        if (!remove) return;
        e.preventDefault();
        this.update(remove.dataset.key, 0);
      });

      this.addEventListener('input', V.utils.debounce((e) => {
        if (!e.target.matches('[data-cart-note]')) return;
        fetch(`${V.routes.cartUpdate}.js`, { ...V.utils.fetchConfig(), body: JSON.stringify({ note: e.target.value }) });
      }, 500));
    }

    update(key, quantity) {
      this.queue = this.queue.then(() => this.request(key, quantity));
    }

    async request(key, quantity) {
      const item = key ? this.querySelector(`.cart-item[data-key="${CSS.escape(key)}"]`) : null;
      item?.classList.add('is-loading');
      if (quantity === 0) item?.classList.add('is-removing');
      try {
        const res = await fetch(`${V.routes.cartChange}.js`, {
          ...V.utils.fetchConfig(),
          body: JSON.stringify({ id: key, quantity, sections: [this.sectionId], sections_url: window.location.pathname }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || V.strings.cartError);
        const html = new DOMParser().parseFromString(data.sections[this.sectionId], 'text/html');
        const fresh = html.querySelector('vt-cart-page');
        if (fresh) {
          this.innerHTML = fresh.innerHTML;
          V.Reveal.init(this);
          this.querySelectorAll('[data-reveal], [data-reveal-image]').forEach((el) => el.classList.add('is-revealed'));
        }
        V.Cart?.setCount(data.item_count);
        const focusTarget = this.querySelector(`input[data-key="${CSS.escape(key)}"]`) || this.querySelector('h1');
        focusTarget?.focus({ preventScroll: true });
      } catch (e) {
        item?.classList.remove('is-loading', 'is-removing');
        const errors = this.querySelector('#CartErrors');
        if (errors) {
          errors.hidden = false;
          errors.textContent = e.message;
        }
      }
    }
  }

  if (!customElements.get('vt-cart-page')) customElements.define('vt-cart-page', VtCartPage);
})();
